import React, {useEffect, useState} from 'react';
import '../administrar/misDatos/MisDatos.css';
import CuentaService from "../../services/CuentaService";
import {MensajeError} from "../MensajeError";
import {MensajeOk} from "../MensajeOk";
import {ValidacionAutenticado} from "../../components/validaciones/ValidacionAutenticado";
import FeedbackSpinner from "../../components/feedback/FeedbackSpinner";
import {MisDatosContacto} from "../administrar/misDatos/MisDatosContacto";
import {useLocation, useNavigate} from "react-router-dom";
import {getRedirectTo} from "../../routing/redirectUtils";
import {refrescarEstadoUsuario} from "../../security/OidcManager";

export const MisDatosPrimerLogin = () => {

    const [contactoPredeterminado, setContactoPredeterminado] = useState({
        id: '',
        nombre: '',
        apellido: '',
        direccion: '',
        telefono: '',
        emailPublico: '',
        email: '',
        mailConfirmacion: '',
    });
    const [redirectTO, setRedirectTo] = useState(null);
    const [isProcesando, setIsProcesando] = useState(false);

    const [mensajeOk, setMensajeOk] = useState("");
    const [error, setError] = useState({
        error: false,
        mensaje: "Sin errores",
        campo: ""
    });

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setIsProcesando(false);
        setRedirectTo(getRedirectTo(location));
    }, [location])

    const guardarDatosContacto = async (requestDTO) => {
        setIsProcesando(true);
        setError({error: false, mensaje: "Sin errores", campo: ""});

        try {
            const response = await CuentaService.crearContactoPredeterminadoUsuario(requestDTO);
            if (response.respCodigo !== 'OK') {
                setError({
                    error: true,
                    mensaje: response.respMensaje,
                    campo: ""
                });
                return;
            }

            if (!response.contactoDTO?.id) {
                throw new Error("La creación del contacto no devolvió el contacto persistido");
            }

            setContactoPredeterminado({
                ...response.contactoDTO,
                mailConfirmacion: response.contactoDTO.email
            });
            await refrescarEstadoUsuario();
            navigate(redirectTO || "/");
        } catch (error) {
            console.error("Error guardando los datos de contacto", error);
            setError({
                error: true,
                mensaje: "No fue posible guardar los datos de contacto. Intente nuevamente.",
                campo: ""
            });
        } finally {
                setIsProcesando(false);
        }
    }

    function actualizarDatosContacto (contactoPredeterminado) {
        setContactoPredeterminado(contactoPredeterminado);
    }

    return <>
        <ValidacionAutenticado/>

        {mensajeOk !== undefined && mensajeOk !== "" && <MensajeOk mensajeOk={mensajeOk}/>}
        {error !== undefined && error.error && <MensajeError mensajeError={error.mensaje}/>}

        <h2><strong>Mis Datos</strong></h2>

        { isProcesando?
            <div>
                <FeedbackSpinner open={isProcesando} message={'Guardando datos...'}/>
            </div> : <></>
        }

        <div className="cfx">
            <p className="msjRequerido right">Los campos marcados con * son requeridos.</p>
        </div>

        <MisDatosContacto
            contactoPredeterminado={contactoPredeterminado}
            actualizarDatosContacto={actualizarDatosContacto}
            titulo={"Datos de Contacto Públicos"}
            editarDatosContacto={false}
            setEditarDatosContacto={() => {}}
            guardarDatosContacto={guardarDatosContacto}
            guardando={isProcesando}
            setMensajeOk={setMensajeOk}>
        </MisDatosContacto>

    </>
}